import { Avatar, AvatarProps } from '@synoptic/ui-kit/avatar/avatar.js';
import { getUserAvatarSrc } from './get-user-avatar-src';

export type S3AvatarProps = {
  s3Key?: string;
  userId: string;
} & Omit<AvatarProps, 'imageSrc'>;

export const S3Avatar: React.FC<S3AvatarProps> = ({
  s3Key,
  userId,
  size = 'small',
  ...avatarProps
}) => (
  <Avatar
    imageSrc={getUserAvatarSrc(userId, s3Key, size)}
    size={size}
    {...avatarProps}
  />
);
